import { CompanyContext } from "contexts/CompanyContext";
import React, { useContext, useState } from "react";
import { BiMessageRounded } from 'react-icons/bi';
import { AiOutlineRetweet, AiOutlineHeart } from 'react-icons/ai';
import { IoStatsChartOutline } from 'react-icons/io5';
import { FiShare } from 'react-icons/fi';
import { HiOutlineDotsHorizontal } from "react-icons/hi";
import { BsBookmark, BsChat, BsHeart, BsSend } from "react-icons/bs";
import { TbMessageCircle } from "react-icons/tb";
import { formatNumber } from "utils/formatNumber";
import { FaGlobeAmericas } from "react-icons/fa";
import MediaPreview from "./components/MediaPreview";
import TextPreview from "./components/TextPreview";
import AddAssetButton from "./components/AddAssetButton";
import usePostValidator from "utils/hooks/usePostValidator";

const LinkedinPreview = (post) => {

    const {
        id,
        user_id,
        user_name,
        username,
        user_image,
        created_at,
        text,
        media,
        assets,
        like_count,
        comment_count,
        view_count,
        retweet_count,
        className,

        postIndex,
        isEditable,
        onAssetDelete,
        onAssetEdit,
        onAssetNew,
        onTextEdit, 
        onCreateNetworkPost,
        onDeleteIndexPost,
        allPosts = []
    } = post;

    const network = "linkedin";
    const { company, companySocials } = useContext(CompanyContext);
    const integration = companySocials?.filter(e => e.type == network)?.[0];

    return (
        <div className={`instagram rounded-2xl flex flex-col ${className}`}>
            <div className="flex items-center justify-between w-full p-4 py-3">
                <div className="flex items-center gap-3">
                    <img src={user_image || integration?.image?.url || company?.image?.url || `/img/socials-rounded/${network}.svg`} className="rounded-full h-12 w-12" />
                    <div className="flex flex-col w-full">
                        <span className="!text-sm font-bold text-tertiary-700 dark:text-gray-100">{user_name || integration?.name || company?.name}</span>
                        <span className="!text-xs font-light">{new Date(created_at ? created_at : new Date()).getDate()} {new Date(created_at ? created_at : new Date()).toLocaleString('default', { month: 'short' })} · <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" data-supported-dps="16x16" fill="currentColor" className="inline-block" width="16" height="16" focusable="false"><path d="M8 1a7 7 0 107 7 7 7 0 00-7-7zM3 8a5 5 0 011-3l.55.55A1.5 1.5 0 015 6.62v1.07a.75.75 0 00.22.53l.56.56a.75.75 0 00.53.22H7v.69a.75.75 0 00.22.53l.56.56a.75.75 0 01.22.53V13a5 5 0 01-5-5zm6.24 4.83l2-2.46a.75.75 0 00.09-.8l-.58-1.16A.76.76 0 0010 8H7v-.19a.51.51 0 01.28-.45l.38-.19a.74.74 0 01.68 0L9 7.5l.38-.7a1 1 0 00.12-.48v-.85a.78.78 0 01.21-.53l1.07-1.09a5 5 0 01-1.54 9z"></path></svg></span>
                    </div>
                </div>
            </div>
            <div className="px-4 pb-4">
                <TextPreview 
                    text={text} 
                    network={network} 
                    isEditable={isEditable}
                    post={post}
                    onTextEdit={(value) => onTextEdit(postIndex, value)}
                />
            </div>
            {!!assets?.length && 
                <div className="w-full grid grid-cols-2">
                    {assets?.map((asset, key) => (
                        <MediaPreview 
                            asset={asset} 
                            parentClassName={`${assets?.length == 1 ? `col-span-2` : assets?.length%2 == 1 && key == 0 ? `aspect-[16/10] col-span-2` : `aspect-square`}`}
                            className={`w-full h-full object-cover`} 
                            network={network}
                            isEditable={isEditable}
                            onAssetDelete={() => onAssetDelete(postIndex, key)}
                            onAssetEdit={(src) => onAssetEdit(postIndex, key, src)}
                        />
                    ))}
                </div>
            }
            {isEditable && 
                <div className="px-4 py-2">
                    <AddAssetButton 
                        network={network}
                        onAssetNew={(asset) => onAssetNew(postIndex, asset)}
                        onAssetDelete={(assetIndex) => onAssetDelete(postIndex, assetIndex)}
                        post={post}
                        allPosts={allPosts}
                    />
                </div>
            }
            <div className="flex items-center justify-between w-full p-4 py-3">
                <div className="flex gap-0 items-center">
                    <img src="/img/linkedin/like.svg" className="w-5 h-5 rounded-full border-2 border-white dark:border-gray-800 z-[5] relative inline-block" />
                    <img src="/img/linkedin/clap.svg" className="w-5 h-5 rounded-full border-2 border-white dark:border-gray-800 z-[10] -ml-2 relative inline-block" />
                    <img src="/img/linkedin/heart.svg" className="w-5 h-5 rounded-full border-2 border-white dark:border-gray-800 z-[15] -ml-2 relative inline-block" />
                    {like_count > 0 && <span className="!text-xs text-tertiary-700 ml-2">{formatNumber(like_count, 0)}</span>}
                </div>
                <div className="flex gap-5">
                    {comment_count > 0 ? <span className="!text-xs text-tertiary-700">{comment_count} comments</span> : <></>}
                </div>
            </div>
        </div>
    )
}

export default LinkedinPreview;